import React, { useRef, useEffect, useState } from 'react';
import { InputText } from 'primereact/inputtext';

const FaDate = ({ value, onChange }) => {
    const ddRef = useRef(null);
    const mmRef = useRef(null);
    const yyRef = useRef(null);
    const [dd, setDay] = useState("");
    const [mm, setMonth] = useState("");
    const [yy, setYear] = useState("");

    useEffect(() => {
        if(value){
            var str = value.toString();
            if(str.length == 8){
                setDay(str.substring(6, 8));
                setMonth(str.substring(4, 6));
                setYear(str.substring(0, 4));
            }
            else if(str.length == 10){
                setDay(str.substring(8, 10));
                setMonth(str.substring(5, 7));
                setYear(str.substring(0, 4));
            }
        }
    }, [value]); // Re-run effect if data, width, or height changes
    const onInputChange = function(e, name){
        var d = 0;
        if(dd != "") d = parseInt(dd);
        var m = 0;
        if(mm != "") m = parseInt(mm);
        var y = 0;
        if(yy != "") y = parseInt(yy);
        var val = '';
        val = (e.target && e.target.value) || '';
        if(name == "dd"){
            setDay(val);
             d = 0;
            if(val != ""){
                var n = parseInt(val);
                d = n;
                if((n >= 10)&&(n<=31)){
                    mmRef.current.focus();
                }
                else if((n>3)&&(n<10)&&(val.length==1)){
                    setDay("0" +val);
                    mmRef.current.focus();
                }
                else if((n>0)&&(val.length == 2)){
                    mmRef.current.focus();
                }
            }
        }
        else if(name == "mm"){
            setMonth(val);
            m = 0;
            if(val != ""){
                var n = parseInt(val);
                m = n;
                if((n >= 10)&&(n<=12)){
                    yyRef.current.focus();
                }
                else if((n>1)&&(n<10)&&(val.length==1)){
                    setMonth("0" +val);
                    yyRef.current.focus();
                }
                else if((n>0)&&(val.length == 2)){
                    yyRef.current.focus();
                }
            }
        }
        else if(name == "yy"){
            setYear(val);
            y = 0;
            if(val != ""){
                var n = parseInt(val);
                y = n;
            }
        }

        if((y <1320)||(y>1420)) {
            onChange(0);
            return;
        }
        if((m<1)||(m>12)) {
            onChange(0);
            return;
        }
        if((d<1)||(d>31)){
            onChange(0);
            return;
        }
        if((m > 6)&&(d >30)){
            onChange(0);
            return;            
        }
        var date = y.toString();
        if(m<10) date += "0";
        date += "" + m.toString();
        if(d < 10) date += "0";
        date += d.toString();

        onChange(parseInt(date));
        return;  
    }

    return (
        <>
        <div style={{border:"1px solid #a0a0a0", width:"120px", height:"36px", position:"relative", borderRadius:"5px", backgroundColor:"#fff"}}>
            <InputText onChange={(e) => onInputChange(e, "dd")} value={dd} ref={ddRef} style={{position:"absolute", right:"3px", top:"3px", width:"25px", border:"1px solid #fff", outline:"1px solid #fff", textAlign:"center", padding:"2px 0px", borderRadius:"0px"}} maxLength={2} keyfilter={'int'} />
            <div style={{textAlign:"center", position:"absolute", right:"30px", top:"6px", width:"7px"}}>/</div>
            <InputText onChange={(e) => onInputChange(e, "mm")} value={mm} ref={mmRef} style={{position:"absolute", right:"40px", top:"3px", width:"25px", border:"1px solid #fff", outline:"1px solid #fff", textAlign:"center", padding:"2px 0px", borderRadius:"0px"}} maxLength={2} keyfilter={'int'} />
            <div style={{textAlign:"center", position:"absolute", right:"68px", top:"6px", width:"7px"}}>/</div>
            <InputText onChange={(e) => onInputChange(e, "yy")} value={yy} ref={yyRef} style={{position:"absolute", right:"78px", top:"3px", width:"35px", border:"1px solid #fff", outline:"1px solid #fff", textAlign:"center", padding:"2px 0px", borderRadius:"0px"}} maxLength={4} keyfilter={'int'} />
        </div>
        </>
    )
};

export default FaDate;